import React from "react";
import {
	List,
	Datagrid,
	TextField,
	Filter,
	SelectInput,
	Pagination,
	Button,
	TextInput,
} from "react-admin";
import { Clear } from '@material-ui/icons';

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

const PostFilter = (props) => (
	<Filter {...props}>
		<TextInput source="email" label="Email" alwaysOn />
		<SelectInput source="status" label="Status" choices={[
			{ id: 'Pending', name: 'Pending' },
			{ id: 'Approved', name: 'Approved' },
			{ id: 'Rejected', name: 'Rejected' },
		]} alwaysOn />
		 <Button
			label="Clear Filters"
			onClick={() => {
				// 清除所有过滤器
				props.setFilters({}, []);
			}}
			alwaysOn
		  >
			<Clear />
          </Button>
	</Filter>
);

const PostList = ({ permissions, ...props }) => (
	<List {...props} pagination={<PostPagination />} filters={<PostFilter />} bulkActionButtons={false} exporter={false} title={'App versions'}>
		<Datagrid rowClick="edit">
			<TextField source="user.name" label="User Name" />
			<TextField source="user.email" label="User Email" />
			<TextField source="platform" title="Platform" />
			<TextField source="url" label="URL" />
			<TextField source="description" label="Description" />
			<TextField source="status" label="Status" />
			<TextField source="reject_reason" label="Reject Reason" />
			<TextField source="createdAt" label="Created Date" />
		</Datagrid>
	</List>
);

export default PostList;
